(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('EconomicGroupFranchiserUpdateClusterController', EconomicGroupFranchiserUpdateClusterController)

    /** @ngInject */
    function EconomicGroupFranchiserUpdateClusterController(EconomicGroupService, HelperService, NotifyService) {
        const vm = this;

        vm.onFileSelected = file => vm.selectedFile = file;

        vm.onUpdate = () => {
            HelperService.startLoading('.page-content');

            const reader = new FileReader();

            reader.readAsBinaryString(vm.selectedFile);
            reader.onload = evt => {
                const data = evt.target.result;

                const workbook = XLSX.read(data, {
                    type: 'binary'
                });

                const dataTable = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);
                const economicGroups = dataTable.reduce((acc, cur) => {
                    const keys = Object.keys(cur);

                    acc.push({
                        Id: parseInt(cur[keys[0]]),
                        ClusterPerformanceId: parseInt(cur[keys[1]])
                    });

                    return acc;
                }, []);

                if (economicGroups.find(x => x.Id == 0 || x.ClusterPerformanceId == 0)) {
                    NotifyService.error('Planilha com dados inválidos.');
                    HelperService.stopLoading('.page-content');
                    return;
                }

                updateEconomicGroups(economicGroups);
            }
        };

        init();

        function updateEconomicGroups(economicGroups) {
            EconomicGroupService
                .putList(economicGroups)
                .then(() => {
                    NotifyService.success('Grupos de lojas atualizados com sucesso!');
                    HelperService.stopLoading('.page-content');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.page-content');
                });
        }

        function init() {
            vm.selectedFile = null;
        }
    }
}());